import { secondsToMs } from 'common/helpers';
import { AppConfigService } from 'features/app-config/services';

export const autoUpdateSessionActivityTimeMs = () =>
  secondsToMs(AppConfigService.autoUpdateSessionActivityTime);
